<template>
  <div class="stats-bar">
    <div v-for="stat in stats" :key="stat.label" class="stat">
      <h2 class="num">{{ stat.value }}</h2>
      <p class="label">{{ stat.label }}</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      stats: [
        { value: '5,000+', label: 'CASES REVIEWED' },
        { value: '$1.8M', label: 'FUNDS RECOVERED' },
        { value: '94.7%', label: 'SUCCESS RATE' },
        { value: '40+', label: 'COUNTRIES SERVED' },
        { value: '24/7', label: 'LIVE MONITORING' },
        { value: '10+', label: 'ACTIVE SERVICES' }
      ]
    };
  }
}
</script>

<style scoped>
.stats-bar {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  border-top: 1px solid #1f2937;
  border-bottom: 1px solid #1f2937;
  background: #0d1117;
  text-align: center;
  padding: 30px 0;
}

.num {
  color: #00ff88;
  font-size: 2.5rem;
  margin: 0 0 10px;
}

.label {
  color: #a0b3cc;
  font-size: 0.8rem;
  letter-spacing: 1px;
}

@media (max-width: 900px) {
  .stats-bar {
    grid-template-columns: repeat(3, 1fr);
    gap: 30px;
  }

  .num {
    font-size: 1.8rem;
  }
}

@media (max-width: 600px) {
  .stats-bar {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>